export enum MediaType {
    mpd = 'application/dash+xml',
    m3u8 = 'application/x-mpegURL',
    mp4 = 'video/mp4'
}

export function sourceType(sourceUrl?: string): MediaType {
    if (!sourceUrl) {
        return MediaType.mp4;
    }

    // not using new URL to handle relative URLs
    const pathname = sourceUrl.split('?')[0];

    if (pathname.endsWith('.mpd')) {
        return MediaType.mpd;
    }

    if (pathname.endsWith('.m3u8')) {
        return MediaType.m3u8;
    }

    return MediaType.mp4;
}
